import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import { actionCreators } from 'dux/usersInviteSignup';
import getUsersInviteSignupState from 'dux/usersInviteSignup/selectors';
import ErrorPage from 'components/ErrorPage/ErrorPage';
import LoadingPlaceholder from 'components/LoadingPlaceholder/LoadingPlaceholder';
import UserInvitationSignup from './UserInvitationSignup';

const propTypes = {
  error: PropTypes.shape({
    status: PropTypes.number,
    response: PropTypes.shape({
      error: PropTypes.string,
    }),
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  validateInviteToken: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
};

class UserInvitationSignupContainer extends React.Component {
  componentDidMount() {
    const {
      validateInviteToken,
      location: { search },
    } = this.props;
    validateInviteToken(search.slice(search.indexOf('=') + 1));
  }

  render() {
    const { error, isLoading } = this.props;
    if (isLoading) {
      return <LoadingPlaceholder />;
    }
    return error ? (
      <ErrorPage errorStatusCode={`${error.status}`} error={error.response} />
    ) : (
      <UserInvitationSignup {...this.props} />
    );
  }
}

const mapStateToProps = (state) => ({
  ...getUsersInviteSignupState(state),
});

const mapDispatchToProps = {
  validateInviteToken: actionCreators.validateInviteToken,
  acceptInvitation: actionCreators.acceptInvitation,
  acceptInvitationRedirect: actionCreators.acceptInvitationRedirect,
};

UserInvitationSignupContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(UserInvitationSignupContainer);
